
import { defineComponent } from 'vue';
import store from '@/store';
import { GlobalPagination } from '@/interfaces/panel/global-pagination.model';
import IpgTransactionSkelton from '@/components/transactionsComponents/IpgTransactionSkelton.vue';
import ExternalTransactionsTable from '@/components/transactionsComponents/ExternalTransactionsTable.vue';
import CustomPaginationComponent from '@/components/appComponents/CustomPagination.vue';
import router from '@/router';

export default defineComponent({
  name: 'TransactionsListPage',
  components: {
    IpgTransactionSkelton,
    ExternalTransactionsTable,
    CustomPaginationComponent,
  },
  data() {
    return {
      user: '',
    };
  },
  computed: {
    getLoadingPanel(): boolean {
      return store.getters['panel/getLoadingPanel'];
    },
    getGatewayTransactions(): any[] {
      return store.getters['panel/getGatewayTransactions'];
    },
    getGlobalPagination(): GlobalPagination {
      return store.getters['panel/getGlobalPagination'];
    },
  },
  methods: {
    back(): void {
      router.back();
    },
    handelPagination() {
      const gatewayId = this.$route.query.gateway;
      store.dispatch('panel/getGatewayTransactionsRequest', gatewayId);
    },
  },
  mounted() {
    const gatewayId = this.$route.query.gateway;
    store.dispatch('panel/getGatewayTransactionsRequest', gatewayId);
  },
});
